"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProviderVisible = void 0;
var _models = require("../models");
const APPLE_PAY_ID = 527;
const SAFARI = 'Safari';
const CHROME = 'Chrome';
const isProviderVisible = function(id, visibility) {
    let isVisibleForNewOrder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    const { userAgent } = window.navigator;
    const isSafari = userAgent.includes(SAFARI) && !userAgent.includes(CHROME);
    let isVisible = true;
    if (visibility === undefined) {
        isVisible = isVisibleForNewOrder;
    } else {
        // eslint-disable-next-line no-bitwise -- have to use for flags
        isVisible = _models.ProviderVisibility.NewOrder === (visibility & _models.ProviderVisibility.NewOrder);
    }
    return id === APPLE_PAY_ID ? isSafari && isVisible : isVisible;
};
exports.isProviderVisible = isProviderVisible;
